import React from 'react';
import PropTypes from 'prop-types';
import './CodeBlock.css';

/**
 * CodeBlock — exception surface for syntax-colored code/JSON/logs.
 * Uses --code-* tokens only inside this component.
 */
export function CodeBlock({
  children,
  language,
  className = '',
}) {
  return (
    <pre
      className={['onyx-code-block', className].filter(Boolean).join(' ')}
      data-language={language || undefined}
      data-testid="onyx-code-block"
    >
      <code>{children}</code>
    </pre>
  );
}

CodeBlock.propTypes = {
  children: PropTypes.node,
  language: PropTypes.string,
  className: PropTypes.string,
};

/**
 * Prose — chat/markdown body rhythm with brand fonts.
 */
export function Prose({ children, className = '' }) {
  return (
    <div
      className={['onyx-prose', className].filter(Boolean).join(' ')}
      data-testid="onyx-prose"
    >
      {children}
    </div>
  );
}

Prose.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default CodeBlock;
